import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import AppWrapper from 'AppWrapper';
import Dashboard from 'features/dashboard/Dashboard';
import Settings from 'features/settings/Settings';
import { ROUTE_PATHS } from 'app/utils/route';
import SignIn from 'auth/login';
import { RequireAuth } from 'auth/RequireAuth';
import { Groups } from 'components/groups/groups';
import { User } from 'components/user/user';
import { GroupID } from 'components/groups/groupId';
import PasswordModal from 'components/user/changePass';
import { ExecuterID } from 'components/groups/executerId';
import { APCMUserEvent } from 'components/userLog/userLogEvent';
import { ExecutorLogs } from 'components/groups/logRequest';
import ApcmDashboard from 'features/apcm_Dashboard/admin_Dashboard';
import { AssetsLiveData } from 'components/groups/assetLiveData';
import { PriceReqStatic } from 'components/groups/priceReqStatic';
import { PriceExecStatic } from 'components/groups/priceExecStatic';
import { AuthExecData } from 'components/groups/authExecData';
import { GroupsByID } from 'components/groups/groupByID';
import { NotConfirmed } from 'components/groups/noConfirmed';
import { Liscense } from 'components/copyright/liscense';

export default function AppRoutes() {
    return (
        <BrowserRouter>
           <Liscense />
            <Routes>
                <Route path="login" element={<SignIn />} />
                <Route
                    path="/"
                    element={
                        <RequireAuth>
                            <AppWrapper />
                        </RequireAuth>
                    }
                >
                    <Route index element={<Dashboard />} />

                    <Route
                        path={`${ROUTE_PATHS.home}`}
                        element={<Dashboard />}
                    />
                    <Route
                        path={`${ROUTE_PATHS.priceRequest}`}
                        element={<PriceReqStatic />}
                    />
                    <Route
                        path={`${ROUTE_PATHS.groupsByID}`}
                        element={<GroupsByID />}
                    />
                    <Route
                        path={`${ROUTE_PATHS.priceRequestExec}`}
                        element={<PriceExecStatic />}
                    />
                    <Route
                        path={`${ROUTE_PATHS.noConfirmed}`}
                        element={<NotConfirmed />}
                    />
                    <Route
                        path={`${ROUTE_PATHS.assetsLiveData}/:id`}
                        element={<AssetsLiveData />}
                    />
                    <Route
                        path={`${ROUTE_PATHS.assetsLiveData}`}
                        element={<AssetsLiveData />}
                    />
                    <Route
                        path={`${ROUTE_PATHS.groups}`}
                        element={<Groups />}
                    />
                    <Route path={`${ROUTE_PATHS.user}`} element={<User />} />
                    <Route
                        path={`${ROUTE_PATHS.executorLogs}`}
                        element={<ExecutorLogs />}
                    />
                    <Route
                        path={`${ROUTE_PATHS.changePassword}/:id`}
                        element={<PasswordModal />}
                    />
                    <Route
                        path={`${ROUTE_PATHS.groupId}/:id`}
                        element={<GroupID />}
                    />
                     <Route
                        path={`${ROUTE_PATHS.groupId}`}
                        element={<GroupID />}
                    />
                    <Route
                        path={`${ROUTE_PATHS.tableData}/:id`}
                        element={<AuthExecData />}
                    />
                    <Route
                        path={`${ROUTE_PATHS.executor}/:id`}
                        element={<ExecuterID />}
                    />
                     <Route
                        path={`${ROUTE_PATHS.executor}`}
                        element={<ExecuterID />}
                    />
                    <Route
                        path={`${ROUTE_PATHS.executorLogsByID}/:id`}
                        element={<ExecutorLogs />}
                    />

                    <Route path={ROUTE_PATHS.settings} element={<Settings />} />

                    <Route
                        path={ROUTE_PATHS.userEvent}
                        element={<APCMUserEvent />}
                    />
                    <Route
                        path={ROUTE_PATHS.apcmDashboard}
                        element={<ApcmDashboard />}
                    />
                    <Route path="*" element={<Navigate to="/" />} />
                </Route>
            </Routes>
        </BrowserRouter>
    );
}
